<template>
  <el-dialog
    title="选择图片"
    class="uploaderImgVariant"
    v-if="value"
    :visible.sync="value"
    width="1000px"
    append-to-body
    :before-close="onClose">
    <el-alert
      title="变体图片最多选择1张"
      type="error"
      :closable="false"></el-alert>
    <el-divider></el-divider>
    <ul class="select-img" v-if="imgList.length">
      <li
        class="option"
        v-for="(item, index) in imgList"
        :key="item"
        @click="changeVariantSelectImg(item, index)">
        <div
          class="img-mask"
          v-if="variantCheckedImgUidList.some((key) => key === item)">
          <i class="el-icon-upload-success el-true-check">
            {{ getVariantSelectImgIndex(item) }}
          </i>
        </div>
        <img :src="item" alt />
      </li>
    </ul>
    <!-- <el-divider v-if="imgList.length"></el-divider>
    <el-upload
      class="custom-update"
      :action="uploadAction"
      accept="image/gif, image/jpeg, image/tiff"
      drag
      multiple
      :show-file-list="false"
      list-type="picture-card"
      :on-success="uploadVariantImagesSuccess"
      :headers="customHeaders">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        将图片拖到此处，或
        <em>点击上传</em>
      </div>
      <div class="el-upload__tip" slot="tip">
        <p>
          图片可批量上传，只支持
          <span style="color: red; font-weight: bold">JPG/TIFF/JPEG</span>
          格式图片，首选
          <span style="color: red; font-weight: bold">JPEG</span>
          格式， 图片的最长边不应低于
          <span style="color: red; font-weight: bold">1600</span>
          像素，最长边不得超过
          <span style="color: red; font-weight: bold">10,000</span>
          像素，不能包含徽标或水印。商品必须是填满
          <span style="color: red; font-weight: bold">85%</span>
          的图片,图片详细标准请参阅Amazon平台要求。
        </p>
      </div>
    </el-upload> -->
    <div slot="footer" class="dialog-footer">
      <el-button size="mini" @click="onClose">
        取 消
      </el-button>
      <el-button size="mini" type="primary" @click="saveVariantSelectImg">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { Baseurl } from '@/api/api/api'
import { ajaxPost } from '../../../api/api/api'

export default {
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false
    },
    imgList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      uploadAction: Baseurl + 'shopeeImage/uploadImage',
      customHeaders: { token: localStorage.getItem('token') },
      variantCheckedImgUidList: []
    }
  },
  computed: {},
  watch: {},
  created() {
    this.roleInfo = JSON.parse(localStorage.getItem('role'))
  },
  methods: {
    onClose() {
      this.variantCheckedImgUidList = []
      this.$emit('input', false)
    },
    changeVariantSelectImg(item) {
      this.variantCheckedImgUidList = [item]
      // if (this.variantCheckedImgUidList.length <= 0) {
      //   this.variantCheckedImgUidList.push(item)
      // } else {
      //   const isHaveIndex = this.variantCheckedImgUidList.findIndex(
      //     (key) => key === item
      //   )

      //   if (isHaveIndex > -1) {
      //     this.variantCheckedImgUidList.splice(isHaveIndex, 1)
      //   } else {
      //     if (this.variantCheckedImgUidList.length < 9) {
      //       this.variantCheckedImgUidList.push(item)
      //     } else {
      //       this.$message.error('变体图片最多选择9张')
      //     }
      //   }
      // }
    },
    getVariantSelectImgIndex(item) {
      const isHaveIndex = this.variantCheckedImgUidList.findIndex(
        (key) => key === item
      )
      return isHaveIndex + 1
    },
    uploadVariantImagesSuccess(response, file) {
      const imgPath = file.response.data
      // this.productPicUrl.push(imgPath);
      this.$emit('addImg', imgPath)
    },
    // 选择图片确定
    saveVariantSelectImg() {
      this.$emit('confirm', this.variantCheckedImgUidList[0])
      this.onClose()
    }
  }
}
</script>

<style lang="scss" scoped>
.select-img {
  width: 100%;
  height: 320px;
  overflow: auto;

  .option {
    width: 148px;
    height: 148px;
    margin: 0 8px 8px 0;
    float: left;
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    position: relative;

    .img-mask {
      position: absolute;
      right: -17px;
      top: -7px;
      width: 46px;
      height: 26px;
      background: #13ce66;
      text-align: center;
      transform: rotate(45deg);

      .el-true-check {
        color: #fff;
        font-size: 12px;
        margin-top: 12px;
        transform: rotate(-45deg);
      }
    }

    img {
      width: 146px;
    }
  }
}

.custom-update {
  /deep/ .el-upload--picture-card {
    background: initial;
    border: initial;
    width: initial;
    height: initial;
    line-height: initial;
  }
}
</style>
